import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Mail, ArrowRight, CheckCircle2 } from "lucide-react";
import { LOGO_URL } from "../assets/images";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MemberForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Backend always returns 200 (doesn't leak which emails exist).
      await axios.post(`${API}/members/forgot-password`, { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error("Erro a processar o pedido. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[hsl(var(--secondary))] flex items-center justify-center p-6" data-testid="member-forgot-page">
      <div className="w-full max-w-md bg-white border border-[hsl(var(--border))] p-10 sm:p-12">
        <a href="/" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="CIEES" className="h-14 w-14" />
          <div>
            <div className="display-heading text-xl text-[hsl(var(--primary))]">CIEES Portugal</div>
            <div className="text-[10px] tracking-[0.28em] uppercase text-[hsl(var(--muted-foreground))]">Recuperar acesso</div>
          </div>
        </a>

        {sent ? (
          <div className="mt-10" data-testid="member-forgot-success">
            <CheckCircle2 className="h-10 w-10 text-[hsl(var(--primary))]" />
            <h1 className="display-heading text-3xl mt-5 leading-[1.1]">Verifique o seu email.</h1>
            <span className="accent-rule mt-6 block" />
            <p className="mt-6 text-[hsl(var(--muted-foreground))] leading-relaxed">
              Se existir uma conta associada a <strong>{email}</strong>, enviámos um link para criar uma nova palavra-passe. O link é válido durante 1 hora.
            </p>
            <p className="mt-4 text-xs text-[hsl(var(--muted-foreground))]">
              Não recebeu? Verifique a pasta de Spam ou tente novamente passados 2 minutos.
            </p>
            <Link to="/membros/login" className="mt-8 inline-flex items-center gap-2 text-sm uppercase tracking-[0.18em] text-[hsl(var(--primary))] font-medium" data-testid="member-forgot-back-to-login">
              ← Voltar ao login
            </Link>
          </div>
        ) : (
          <>
            <h1 className="display-heading text-3xl mt-10 leading-[1.1]">Esqueceu a palavra-passe?</h1>
            <span className="accent-rule mt-6 block" />
            <p className="mt-6 text-[hsl(var(--muted-foreground))] leading-relaxed text-[15px]">
              Indique o email da sua conta de sócio. Vamos enviar-lhe um link para criar uma nova palavra-passe.
            </p>

            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="member-forgot-form">
              <div>
                <label className="block text-xs uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))] mb-2">Email</label>
                <div className="relative">
                  <Mail className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-[hsl(var(--muted-foreground))]" />
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full bg-white border border-[hsl(var(--border))] py-2.5 pl-10 pr-3 text-[15px] focus:outline-none focus:border-[hsl(var(--accent))]"
                    placeholder="o.seu.email@exemplo.com"
                    data-testid="member-forgot-email"
                  />
                </div>
              </div>
              <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60" data-testid="member-forgot-submit">
                {loading ? "A enviar…" : "Enviar link"} <ArrowRight className="h-4 w-4" />
              </button>
            </form>

            <div className="mt-7 flex items-center justify-between text-sm">
              <Link to="/membros/login" className="text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--primary))]" data-testid="member-forgot-link-login">← Voltar ao login</Link>
              <Link to="/membros/registar" className="text-[hsl(var(--primary))] hover:underline">Ainda não sou sócio →</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
